var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_9994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13078 0 0 3.13105 0 7C0 10.8692 3.13105 14 7 14C10.8692 14 14 10.8689 14 7C14 3.13078 10.8689 0 7 0ZM7 12.9062C3.73535 12.9062 1.09375 10.2644 1.09375 7C1.09375 3.73535 3.73557 1.09375 7 1.09375C10.2647 1.09375 12.9062 3.73557 12.9062 7C12.9062 10.2647 10.2644 12.9062 7 12.9062Z",
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.52393C6.69796 3.52393 6.45312 3.76876 6.45312 4.0708V7.59249C6.45312 7.89452 6.69796 8.13936 7 8.13936C7.30204 8.13936 7.54688 7.89452 7.54688 7.59249V4.0708C7.54688 3.76876 7.30204 3.52393 7 3.52393Z",
    fill: "#FF6F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.2856C7.40774 10.2856 7.73828 9.9551 7.73828 9.54736C7.73828 9.13962 7.40774 8.80908 7 8.80908C6.59226 8.80908 6.26172 9.13962 6.26172 9.54736C6.26172 9.9551 6.59226 10.2856 7 10.2856Z",
    fill: "#FF6F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_9994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/ExclamationIcon.b0dbff093ec4986a8fde4efa853cdb75.svg";
export { ForwardRef as ReactComponent };